import React, { createRef, forwardRef, useImperativeHandle } from 'react';
import { useSelector } from 'react-redux';

// Styles
import './about-tab.scss';

// Components
import { CompanyName, TCompanyNameRef } from './children/company-name/company-name';
import { WebAppUrl, TWebAppUrlRef } from './children/web-app-url/web-app-url';
import { About, TAboutRef } from './children/about/about';

// Store entities
import { getCompanyState } from '../../../../store/company/company.selectors';

export type TBusinessAboutRef = {
  isHasChanges: () => boolean;
  resetState: () => void;
};

type TBusinessAboutProps = {};

export const AboutTab = forwardRef<TBusinessAboutRef, TBusinessAboutProps>((
  {}: TBusinessAboutProps, ref
) => {
  const companyNameRef = createRef<TCompanyNameRef>();
  const webAppUrlRef = createRef<TWebAppUrlRef>();
  const aboutRef = createRef<TAboutRef>();

  const { company } = useSelector(getCompanyState);

  useImperativeHandle(ref, () => ({
    isHasChanges(): boolean {
      return !!companyNameRef.current?.isHasChanges() ||
      !!webAppUrlRef.current?.isHasChanges() ||
      !!aboutRef.current?.isHasChanges();
    },
    resetState(): void {
      companyNameRef.current?.resetState();
      webAppUrlRef.current?.resetState();
      aboutRef.current?.resetState();
    }
  }));

  return (<>
    {
      company && <div className="about-tab">

        <div className="about-tab--item split-items">
          <CompanyName company={ company }/>
          <WebAppUrl
            companyLinkNotEditable={ `${process.env.REACT_APP_USER_APP_URL}/` }
            companyLinkEditable={ company.url_code ?? '' }
            company={ company }/>
        </div>

        {/*<div className="about-tab--item">*/}
        {/*  <MobileAppUrl company={ company }/>*/}
        {/*</div>*/}

        <div className="about-tab--item">
          <About ref={ aboutRef } company={ company }/>
        </div>

      </div>
    }
  </>);
})
